module.exports = __webpack_public_path__ + "img/PL08913.82482399.png";